<template>
  <base-container :isLoading="isLoading">
    <!-- <van-nav-bar title="个人中心"></van-nav-bar> -->
    <div style="height:100%;">
      <van-row class="user-header">
        <van-col span="4" style="text-align:center;line-height:50px;">
          <van-icon size="3rem" name="contact" color="#fff" />
        </van-col>
        <van-col span="20">
          <van-row style="line-height:25px;" v-text="user.realName"></van-row>
          <van-row style="line-height:25px;font-size:0.7rem" v-text="user.phone"></van-row>
        </van-col>
      </van-row>
      <van-row style="margin-top:7px;">
        <van-cell title="我的订单" is-link to="/order">
          <template #icon>
            <van-image
              style="margin:3px 5px"
              width="17"
              height="17"
              :src="require('@/assets/img/order.png')"
            />
          </template>
        </van-cell>
        <van-cell-group style="margin-top:7px;">
          <van-cell title="水费户号" is-link @click="showWater">
            <van-tag round type="primary">{{user.cusWaterfeeInfos.length}}</van-tag>
            <template #icon>
              <van-image
                style="margin:3px 5px"
                width="17"
                height="17"
                :src="require('@/assets/img/iconwater.png')"
              />
            </template>
          </van-cell>
          <van-cell title="就诊卡" is-link @click="showCard">
            <van-tag round type="success">{{user.cusMedicalCards.length}}</van-tag>
            <template #icon>
              <van-image
                style="margin:3px 5px"
                width="17"
                height="17"
                :src="require('@/assets/img/card.png')"
              />
            </template>
          </van-cell>
        </van-cell-group>
        <van-cell-group style="margin-top:7px;">
          <van-cell title="修改密码" is-link to="/editpwd">
            <template #icon>
              <van-image
                style="margin:3px 5px"
                width="17"
                height="17"
                :src="require('@/assets/img/pwd.png')"
              />
            </template>
          </van-cell>
          <van-cell title="退出" is-link @click="loginOut">
            <template #icon>
              <van-image
                style="margin:3px 5px"
                width="17"
                height="17"
                :src="require('@/assets/img/logout.png')"
              />
            </template>
          </van-cell>
        </van-cell-group>
      </van-row>
      <van-popup v-model="showPopup" position="right" :style="{ width: '100%',height:'100%' }">
        <van-row v-if="isWater">
          <van-nav-bar title="水费户号" left-text="我的" left-arrow @click-left="showPopup=false">
            <template #right>
              <router-link to="/bindwater">
                <van-icon name="plus" size="18" />
              </router-link>
            </template>
          </van-nav-bar>
          <van-empty v-if="hasWater" description="用户未绑定水费户号">
            <!-- <van-button round type="danger" icon="plus" size="normal" class="artisan-btn">绑定水费户号</van-button> -->
          </van-empty>
          <van-cell
            style="background-color: #f7f8fa;margin-top:3px;"
            v-for="(wf,index) in user.cusWaterfeeInfos"
            :key="index"
            :title="wf.waterName"
            icon="chat-o"
            size="large"
            :label="wf.waterNo"
            :value="wf.groupName"
          >
            <template #icon>
              <van-image
                style="margin:3px 5px"
                width="17"
                height="17"
                :src="require('@/assets/img/iconwater.png')"
              />
            </template>
          </van-cell>
        </van-row>
        <van-row v-else>
          <van-nav-bar title="就诊卡" left-text="我的" left-arrow @click-left="showPopup=false">
            <template #right>
              <router-link to="/bindcard">
                <van-icon name="plus" size="18" />
              </router-link>
            </template>
          </van-nav-bar>
          <van-empty v-if="hasCard" description="用户未绑定就诊卡">
            <!-- <van-button round type="danger" icon="plus" size="normal" class="login-btn">绑定就诊卡</van-button> -->
          </van-empty>
          <van-cell
            style="background-color: #f7f8fa;margin-top:3px;"
            v-for="(mc,index) in user.cusMedicalCards"
            :key="index"
            :title="mc.patientName"
            icon="chat-o"
            size="large"
            :label="mc.cardNo"
          >
            <template #icon>
              <van-image
                style="margin:3px 5px"
                width="17"
                height="17"
                :src="require('@/assets/img/card.png')"
              />
            </template>
          </van-cell>
        </van-row>
      </van-popup>
      <van-popup v-model="isAdd" round position="bottom" :style="{ width: '100%',height:'50%' }"></van-popup>
    </div>
  </base-container>
</template>
<script>
import { getUserInfo } from "@/api/customer";
import { getToken, logout } from "@/util/auth";
import { Dialog } from "vant";
export default {
  data() {
    let isYun = false;
    if (window.mc) isYun = false;
    return {
      isLogin: false,
      isLoading: false,
      showPopup: false,
      isWater: false,
      isAdd: false,
      activeNames: ["1", "2"],
      isYunLogin: isYun,
      user: {
        cusWaterfeeInfos: [],
        cusMedicalCards: [],
      },
    };
  },
  computed: {
    hasWater() {
      var bl = true;
      if (this.user.cusWaterfeeInfos && this.user.cusWaterfeeInfos.length > 0) {
        bl = false;
      }
      return bl;
    },
    hasCard() {
      var bl = true;
      if (this.user.cusMedicalCards && this.user.cusMedicalCards.length > 0) {
        bl = false;
      }
      return bl;
    },
  },
  created() {
    if (getToken()) {
      this.isLogin = true;
      this.isLoading = true;
      getUserInfo()
        .then((res) => {
          this.user = res.data.value;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    }
  },
  methods: {
    showWater() {
      this.showPopup = true;
      this.isWater = true;
    },
    showCard() {
      this.showPopup = true;
      this.isWater = false;
    },
    loginOut() {
      Dialog.confirm({
        title: "提示",
        message: "确认要退出？",
      }).then(() => {
        logout();
        this.isLogin = false;
        this.$router.push("/login");
      });
    },
  },
};
</script>
<style>
.user-header {
  padding-top: 7px;
  background: #c71d24;
  color: #fff;
  height: 50px;
}
.user-logout {
  position: absolute;
  bottom: 100px;
}
</style>